<template>
  <page-outline :title="'Test implémentation'">
    <template slot="pageContent">
      <b-row class="justify-content-start">
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="axepta.transId"
            inputLabel="ID Transaction"
            :maxLength="64">
            <a href="" style="color:#007bff;text-decoration:underline;"
              @click="genTransId">
              Aléatoire
            </a>
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="axepta.refNr"
            inputLabel="ID Facture"
            :maxLength="12">
            <a href="" style="color:#007bff;text-decoration:underline;"
              @click="genRefNr">
              Aléatoire
            </a>
          </form-write-group-label-input>
        </b-col>
        <b-col sm="2" class="form-group">
          <form-write-group-label-input v-model="axepta.amount"
            inputLabel="Montant">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="1" class="form-group">
          <form-write-group-label-input
            inputLabel="Devise"
            inputType="listeSelect">
            <select class="form-control" id="sel" readonly v-model="axepta.currency">
              <option value="EUR">EUR</option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-form-radio-group
        id="radioGroupPayment"
        v-model="selectedPayment"
        :options="optionsPayment"
        name="radioGroupPayment">
      </b-form-radio-group>
      <div v-if="selectedPayment === optionsPayment[1]">
        <page-axepta
          :refNr="axepta.refNr"
          :transId="axepta.transId"
          :amount="axepta.amount"
          :currency="axepta.currency"
          :orderDesc="axepta.orderDesc"
          :height="700">
        </page-axepta>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageAxepta from '@/pages/axepta/PageAxepta.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'PaymentFromApplicationTestForm',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-axepta': PageAxepta,
    'page-outline': PageOutline
  },
  data () {
    return {
      axepta: {
        refNr: '',
        transId: '',
        amount: '0',
        currency: 'EUR',
        orderDesc: 'Test:0000'
      },
      optionsPayment: ['Virement Bancaire', 'Carte Bancaire', 'Paiement Instantané'],
      selectedPayment: 'Virement Bancaire'
    }
  },
  methods: {
    genRefNr () {
      let randomRefNr = 'TestSTRM' + Math.floor(Math.random() * (9999 - 1)).toString().padStart(4, '0')
      this.axepta.refNr = randomRefNr
    },
    genTransId () {
      let randomTransId = 'EndToEndId_' + moment().format('YYYYMMDDHHmmss') + '_' + Math.random().toString(36).substr(2, 6)
      this.axepta.transId = randomTransId
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentFromApplicationTestForm.vue?d4dac594